<template>
  <div class="m-paymentOptionsInfo">
    <i class="fa fas fa-lock" aria-hidden="true"></i>
    <span class="pl-5">Secure payments</span>
    <div class="ptb-10">We accept payments via credit card and PayPal.</div>
      <div class="inline-block">
        <img v-bind:src="paymentsAssetUrl.paypal" />
        <img v-bind:src="paymentsAssetUrl.mastercard" />
        <img v-bind:src="paymentsAssetUrl.visa" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState({
    paymentsAssetUrl: state => state.globalstate.paymentsAssetUrl
  })
}
</script>



// WEBPACK FOOTER //
// PaymentsOptionsInfo.vue?b93ef4ea